import { render, staticRenderFns } from "./elevatorDetail.vue?vue&type=template&id=3f614086&"
import script from "./elevatorDetail.vue?vue&type=script&lang=js&"
export * from "./elevatorDetail.vue?vue&type=script&lang=js&"
import style0 from "./elevatorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports